import React from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/SearchOutlined";
import CloseIcon from "@mui/icons-material/CloseOutlined";

// Muted ink used for the icons and the placeholder, so the pill reads as a
// resting field rather than filled-in text.
const MUTED = "rgba(0, 0, 0, 0.54)";

// The Dashboard launchpad search box: a solid white pill floating on the brand
// gradient. Fully rounded, no outline, and compact (36px tall) - the field's
// own fill is the only chrome it needs.
export default function DashboardSearchField({
  inputRef,
  value,
  autoFocus = false,
  onChange,
  onKeyDown,
  onClear,
}) {
  return (
    <TextField
      inputRef={inputRef}
      autoFocus={autoFocus}
      fullWidth
      size="small"
      placeholder="Search ..."
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      sx={{
        maxWidth: 505,
        "& .MuiOutlinedInput-root": {
          background: "#FFFFFF",
          borderRadius: "30px",
          px: "6px",
          gap: "9px",
          minHeight: 36,
        },
        "& .MuiOutlinedInput-notchedOutline": { border: "none" },
        "& .MuiInputBase-input": {
          p: 0,
          fontSize: 16,
          lineHeight: "24px",
          letterSpacing: "0.15px",
          "&::placeholder": { color: MUTED, opacity: 1 },
        },
      }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start" sx={{ m: 0 }}>
              <SearchIcon sx={{ fontSize: 24, color: MUTED }} />
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position="end" sx={{ m: 0 }}>
              <IconButton
                size="small"
                aria-label="Clear search"
                onClick={onClear}
              >
                <CloseIcon fontSize="small" sx={{ color: MUTED }} />
              </IconButton>
            </InputAdornment>
          ) : null,
        },
        htmlInput: { "aria-label": "Search navigation" },
      }}
    />
  );
}
